import React, { useMemo } from 'react'
import { Button, Carousel } from '@material-tailwind/react'
import { PiCaretLeftBold, PiCaretRightBold } from 'react-icons/pi'
import Player from '../components/Player'
import { useXp } from '../contexts/XpContext'
import { useScreenBreakpoint } from '../hooks/toolkit'

const prevArrow = ({ handlePrev }: { handlePrev: () => void }) => (
  <Button onClick={handlePrev} size="sm" variant="text" className="!absolute top-2/4 left-0 -translate-y-2/4">
    <PiCaretLeftBold className="h-6 w-6" />
  </Button>
)

const nextArrow = ({ handleNext }: { handleNext: () => void }) => (
  <Button
    onClick={handleNext}
    size="sm"
    variant="text"
    className="!absolute top-2/4 !right-0 -translate-y-2/4"
  >
    <PiCaretRightBold className="h-6 w-6" />
  </Button>
)

const navigation = ({
  setActiveIndex,
  activeIndex,
  length,
}: {
  setActiveIndex: (index: number) => void
  activeIndex: number
  length: number
}) => (
  <div className="absolute bottom-0 left-2/4 z-50 flex -translate-x-2/4 gap-2">
    {Array.from({ length }, (_, i) => {
      const navColor = activeIndex === i ? 'w-8 bg-primary' : 'w-4 bg-primary/50'
      return (
        <span
          key={`nav-dot-${i}`}
          className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${navColor}`}
          onClick={() => setActiveIndex(i)}
        />
      )
    })}
  </div>
)

const PlayersCarousel = () => {
  const { patterns, active } = useXp()
  const breakpoint = useScreenBreakpoint()

  const bottom = useMemo(() => {
    if (breakpoint === 'sm') return 0
    if (patterns.length > 1) return 84
    return 24
  }, [patterns, breakpoint])

  return (
    <div
      className={`
        absolute w-full md:w-[36rem]
        md:left-1/2 md:-translate-x-1/2
        shadow rounded overflow-hidden z-[999]
      `}
      style={{ bottom }}
    >
      <Carousel className="rounded" prevArrow={prevArrow} nextArrow={nextArrow} navigation={navigation}>
        {active?.map((activeSpot) => (
          <div key={activeSpot.id} className="relative -top-1 text-primary px-6 py-4 w-3/4 mx-auto">
            <Player spot={activeSpot} />
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default PlayersCarousel
